// extracted by mini-css-extract-plugin
module.exports = {"movie-list":"movieList_movie-list__Rff29","title":"movieList_title__2Scrz"};